import AvatarFallback from "./AvatarFallback";
import React from "react";
import { Box, Typography } from "@mui/material";
import { MoreHorizontalIcon } from "../AdaptiveIcon";
import VerifiedIcon from "@mui/icons-material/Verified";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import RepeatRoundedIcon from "@mui/icons-material/RepeatRounded";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import BarChartIcon from "@mui/icons-material/BarChart";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import UploadIcon from "@mui/icons-material/Upload";

const Twitter = ({
  selectedAccounts,
  formattedTags,
  accResp,
  selectedImages,
  selectedIndex,
  avatars,
  postTitle,
  postText,
}) => {
  const numImages = selectedImages.length;

  // Twitter grid layout configurations (max 4 images)
  const getGridStyle = () => {
    if (numImages === 1) {
      return {
        gridTemplateColumns: "1fr",
        gridTemplateRows: "1fr",
      };
    }
    if (numImages === 2) {
      return {
        gridTemplateColumns: "1fr 1fr",
        gridTemplateRows: "1fr",
      };
    }
    if (numImages === 3) {
      return {
        gridTemplateColumns: "1fr 1fr",
        gridTemplateRows: "1fr 1fr",
      };
    }
    return {
      gridTemplateColumns: "1fr 1fr",
      gridTemplateRows: "1fr 1fr",
    };
  };

  return (
    <Box className="tab-pane h-full">
      <Box className="user-container p-10 relative mx-5">
        <Box
          className="instHeader mt-4"
          sx={{
            height: "20px",
            position: "relative",
            marginBottom: selectedAccounts.length === 0 ? "0px" : "30px",
          }}>
          {selectedAccounts.length === 0 ? (
            <Box
              className="avatar"
              sx={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                backgroundColor: "var(--background-preview)",
                position: "absolute",
              }}
            />
          ) : (
            <>
              {selectedAccounts.map((id, i) => {
                const index = accResp.findIndex((acc) => acc.id === id);
                const avatar = avatars[index];
                const userName = accResp[index].username;

                return (
                  <Box
                    key={id}
                    className="author-img"
                    sx={{
                      backgroundColor: "var(--background-preview)",
                      position: "absolute",
                      display: i === selectedIndex ? "flex" : "none",
                      alignItems: "center",
                    }}>
                    <AvatarFallback
                      src={avatar}
                      name={userName}
                      background="#1d9bf0"
                      className="w-full h-full object-cover mr-2"
                      style={{ borderRadius: "50%" }}
                    />
                    <Box className="flex flex-col">
                      <Box className="flex items-center" style={{ gap: "4px" }}>
                        <Typography
                          className="whitespace-nowrap"
                          sx={{
                            marginLeft: "10px",
                            color: "var(--text-color)",
                            fontWeight: 700,
                            fontSize: "15px",
                          }}>
                          {userName}
                        </Typography>
                        <VerifiedIcon sx={{ color: "#1d9bf0", fontSize: "18px" }} />
                      </Box>
                      <Typography
                        className="whitespace-nowrap"
                        sx={{
                          marginLeft: "10px",
                          color: "#71767b",
                          fontSize: "13px",
                        }}>
                        @{userName} · 1m
                      </Typography>
                    </Box>
                  </Box>
                );
              })}
            </>
          )}
          <Box className="absolute right-0">
            <MoreHorizontalIcon fontSize="large" />
          </Box>
        </Box>
        <Box
          className="user-info"
          style={{ position: "relative", paddingLeft: "60px", top: "-25px" }}>
          {selectedAccounts.length === undefined ||
          selectedAccounts.length === 0 ? (
            <>
              <Box
                style={{
                  width: "30%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}
              />
              <Box
                style={{
                  width: "10%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}
              />
            </>
          ) : null}
        </Box>

        {(postTitle === undefined || postTitle === "") &&
        selectedImages.length === 0 ? (
          <Box className="flex flex-col mb-8">
            <Box sx={{ width: "100%", display: "block", alignSelf: "center" }}>
              <Box
                style={{
                  width: "100%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}></Box>
              <Box
                style={{
                  width: "30%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}></Box>
            </Box>
          </Box>
        ) : (
          <Box className="mb-3">
            <Typography
              component="div"
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                marginBottom: "5px",
                color: "var(--text-color)",
              }}>
              {postTitle}
            </Typography>
          </Box>
        )}

        {postText === undefined || postText === "" ? (
          <Box className="flex flex-col mb-2">
            <Box sx={{ width: "85%", display: "block", alignSelf: "center" }}>
              <Box
                style={{
                  width: "100%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}></Box>
              <Box
                style={{
                  width: "70%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}></Box>
              <Box
                style={{
                  width: "50%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}></Box>
            </Box>
          </Box>
        ) : (
          <>
            <Typography
              component="div"
              style={{
                whiteSpace: "pre-wrap",
                overflow: "hidden",
                marginBottom: "5px",
                color: "var(--text-color)",
                fontSize: "15px",
                lineHeight: "1.5",
              }}>
              {postText}
            </Typography>
            <Typography
              component="div"
              style={{
                whiteSpace: "pre-wrap",
                overflow: "hidden",
                marginBottom: "5px",
                color: "#1d9bf0",
                fontSize: "15px",
              }}>
              {formattedTags}
            </Typography>
          </>
        )}

        {selectedImages.length > 0 && (
          <Box className="flex justify-center mb-3">
            <Box
              className="media-preview twitter-gallery"
              style={{ width: "523px", height: "auto", maxHeight: "523px" }}>
              <Box
                className="twitter-gallery-grid"
                style={{
                  display: "grid",
                  gap: "2px",
                  ...getGridStyle(),
                  position: "relative",
                }}>
                {numImages === 1 ? (
                  <img
                    src={selectedImages[0].props.src}
                    alt=""
                    style={{
                      width: "100%",
                      height: "auto",
                      maxHeight: "450px",
                      objectFit: "cover",
                      borderRadius: "16px",
                      border: "1px solid var(--border-color)",
                    }}
                  />
                ) : numImages === 2 ? (
                  selectedImages.slice(0, 2).map((image, index) => (
                    <img
                      key={index}
                      src={image.props.src}
                      alt=""
                      style={{
                        width: "100%",
                        height: "280px",
                        objectFit: "cover",
                        borderRadius: index === 0 ? "16px 0 0 16px" : "0 16px 16px 0",
                        border: "1px solid var(--border-color)",
                      }}
                    />
                  ))
                ) : numImages === 3 ? (
                  <>
                    <img
                      src={selectedImages[0].props.src}
                      alt=""
                      style={{
                        width: "100%",
                        height: "100%",
                        minHeight: "280px",
                        objectFit: "cover",
                        gridRow: "1 / 3",
                        borderRadius: "16px 0 0 16px",
                        border: "1px solid var(--border-color)",
                      }}
                    />
                    {selectedImages.slice(1, 3).map((image, index) => (
                      <img
                        key={index + 1}
                        src={image.props.src}
                        alt=""
                        style={{
                          width: "100%",
                          height: "139px",
                          objectFit: "cover",
                          borderRadius: index === 0 ? "0 16px 0 0" : "0 0 16px 0",
                          border: "1px solid var(--border-color)",
                        }}
                      />
                    ))}
                  </>
                ) : (
                  selectedImages.slice(0, 4).map((image, index) => (
                    <img
                      key={index}
                      src={image.props.src}
                      alt=""
                      style={{
                        width: "100%",
                        height: "139px",
                        objectFit: "cover",
                        borderRadius:
                          index === 0
                            ? "16px 0 0 0"
                            : index === 1
                            ? "0 16px 0 0"
                            : index === 2
                            ? "0 0 0 16px"
                            : "0 0 16px 0",
                        border: "1px solid var(--border-color)",
                      }}
                    />
                  ))
                )}
              </Box>
            </Box>
          </Box>
        )}
        {/* X/Twitter action bar */}
        <Box className="tweet-actions" sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "12px",
          paddingTop: "4px",
          borderTop: "1px solid var(--border-color)",
          color: "#71767b",
        }}>
          <Box className="tweet-action-btn" sx={{ display: "flex", alignItems: "center", gap: "4px", cursor: "pointer", "&:hover": { color: "#1d9bf0" } }}>
            <ChatBubbleOutlineRoundedIcon sx={{ fontSize: "18px" }} />
            <Typography sx={{ fontSize: "13px" }}>24</Typography>
          </Box>
          <Box className="tweet-action-btn" sx={{ display: "flex", alignItems: "center", gap: "4px", cursor: "pointer", "&:hover": { color: "#00ba7c" } }}>
            <RepeatRoundedIcon sx={{ fontSize: "18px" }} />
            <Typography sx={{ fontSize: "13px" }}>8</Typography>
          </Box>
          <Box className="tweet-action-btn" sx={{ display: "flex", alignItems: "center", gap: "4px", cursor: "pointer", "&:hover": { color: "#f91880" } }}>
            <FavoriteBorderIcon sx={{ fontSize: "18px" }} />
            <Typography sx={{ fontSize: "13px" }}>147</Typography>
          </Box>
          <Box className="tweet-action-btn" sx={{ display: "flex", alignItems: "center", gap: "4px", cursor: "pointer", "&:hover": { color: "#1d9bf0" } }}>
            <BarChartIcon sx={{ fontSize: "18px" }} />
            <Typography sx={{ fontSize: "13px" }}>3.2K</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <BookmarkBorderIcon sx={{ fontSize: "18px", cursor: "pointer", "&:hover": { color: "#1d9bf0" } }} />
            <UploadIcon sx={{ fontSize: "18px", cursor: "pointer", "&:hover": { color: "#1d9bf0" } }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Twitter;
